import React from 'react'
import HowItsComponent from '../Components/HowItsComponent'
import Layout from '../Components/Layout/Layout'

const HowIts = () => {
  return (
    <>
    <Layout>
    <HowItsComponent />
    </Layout>
    </>
  )
}

export default HowIts

